import { PaginationResult, SearchUnifiedShipmentsRequest } from '@forto-dev/search-light-models'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

import { OverviewItem } from '../domain/overviewItem'
import { SearchUnifiedShipmentsResponseWithPagination, ShipmentPageParams } from '../types'

const client = new Client(getConfig().API_ENDPOINT ?? '')

export type PaginatedUnifiedShipments = PaginationResult<OverviewItem | null | undefined>

export const getUnifiedShipments = async ({
  pageParam,
}: {
  pageParam: Partial<ShipmentPageParams>
}): Promise<SearchUnifiedShipmentsResponseWithPagination> => {
  // `customs` and `dangerousGoods` are not on SearchUnifiedShipmentsRequest yet — searchlight serves them, the models package still has to catch up
  const requestParams: SearchUnifiedShipmentsRequest & { customs?: boolean; dangerousGoods?: boolean } = {
    limit: pageParam.limit || 20,
    offset: pageParam.offset || 0,
    orderBy: pageParam.orderBy || 'relevance',
    orderByDesc: pageParam.orderByDesc ?? true,
    ...(pageParam.query && { query: pageParam.query }),
    ...(pageParam.status && { status: pageParam.status }),
    ...(pageParam.mainTransportMode && { mainTransportMode: pageParam.mainTransportMode }),
    ...(pageParam.mainTransportType && { mainTransportType: pageParam.mainTransportType }),
    ...(pageParam.shipper && { shipper: pageParam.shipper }),
    ...(pageParam.consignee && { consignee: pageParam.consignee }),
    ...(pageParam.portOfLoading && { portOfLoading: pageParam.portOfLoading }),
    ...(pageParam.portOfDischarge && { portOfDischarge: pageParam.portOfDischarge }),
    ...(pageParam.pickupStartDate && { pickupStartDate: pageParam.pickupStartDate }),
    ...(pageParam.pickupEndDate && { pickupEndDate: pageParam.pickupEndDate }),
    ...(pageParam.deliveryStartDate && { deliveryStartDate: pageParam.deliveryStartDate }),
    ...(pageParam.deliveryEndDate && { deliveryEndDate: pageParam.deliveryEndDate }),
    ...(pageParam.ETAStartDate && { ETAStartDate: pageParam.ETAStartDate }),
    ...(pageParam.ETAEndDate && { ETAEndDate: pageParam.ETAEndDate }),
    ...(pageParam.ETDStartDate && { ETDStartDate: pageParam.ETDStartDate }),
    ...(pageParam.ETDEndDate && { ETDEndDate: pageParam.ETDEndDate }),
    ...(pageParam.cargoReadyStartDate && { cargoReadyStartDate: pageParam.cargoReadyStartDate }),
    ...(pageParam.cargoReadyEndDate && { cargoReadyEndDate: pageParam.cargoReadyEndDate }),
    ...(pageParam.shipmentRequired && { shipmentRequired: pageParam.shipmentRequired }),
    ...(pageParam.bookingRequired && { bookingRequired: pageParam.bookingRequired }),
    ...(pageParam.code && { code: pageParam.code }),
    ...(pageParam.customs != null && { customs: pageParam.customs }),
    ...(pageParam.dangerousGoods != null && { dangerousGoods: pageParam.dangerousGoods }),
  }

  const { items, totalItems, totalPages } = await client.get<SearchUnifiedShipmentsResponseWithPagination>(
    '/api/search-light/search/unifiedShipments',
    {
      params: requestParams,
    }
  )

  return { items, totalItems, totalPages }
}
